import React from 'react';
import { SecondaryButton } from '@sb1/ffe-buttons-react';
import { txt } from './texts';
import classnames from 'classnames';
export var PageButton = React.forwardRef(function (_a, ref) {
    var isActive = _a.isActive, onClick = _a.onClick, children = _a.children, locale = _a.locale;
    return (React.createElement(SecondaryButton, { ref: ref, type: "button", "aria-label": isActive
            ? txt[locale].currentPage(children)
            : txt[locale].goToPage(children), "aria-current": isActive, className: classnames('ffe-pagination-page-button', {
            'ffe-pagination-page-button--active': isActive,
        }), onClick: onClick }, children));
});
